import * as moment from 'moment/moment';

export class BasePlanData {
    dateFormat: string = 'DD/MM/YYYY';

    protected _planStartDate: moment.Moment = moment(new Date(), this.dateFormat);
    protected _actualsPlanStartDate: moment.Moment = moment(new Date(), this.dateFormat);
    protected _planEndDate: moment.Moment = moment(new Date(), this.dateFormat);

    planStartStr: string = '';
    actualsPlanStartStr: string = '';
    planEndStr: string = '';
    /*planDurationYears: number = 0;
    planName: string = '';
    planGUID: string = '';
    planYearEnd: number = 0;
    planCurrencyId: number = 0;
    planCurrencyPosition: number = 0;
    planTourActive: boolean = false;
    planWasNotEdited: boolean = true;
    planLogoBlob: string = '';
    planIsNotFound: boolean = false;
    sharedPlanEditMode: string = '';
    ownerLevel: number = 0;
    ownerMaxPlanDuration: number = 0;
    planUrl: string = '';
    xeroConnected: boolean = false;
    crunchConnected: boolean = false;
    planTaxSystem: string = '';
    autoSync: number = 0;
    isQuickUpdate: number = 0;

    lastView: PlanDataLastView = new PlanDataLastView();
    xeroData: XeroPlanDto = new XeroPlanDto();
    crunchImport?: CrunchImportData;
    reportTypes: ReportModel[] = [];
    actualReportTypes: ReportModel[] = [];
    chartTypes: ChartBaseModel[] = [];*/

    set planStartDate(v: any) {

        //if (typeof v === "string") this.planStartStr = v;
        this._planStartDate = moment(v, this.dateFormat);
        this.planStartStr = this._planStartDate.format(this.dateFormat);

    }    

    get planStartDate() {

        return this._planStartDate.clone();

    }

    set actualsPlanStartDate(v: any) {

        this._actualsPlanStartDate = moment(v, this.dateFormat);
        this.actualsPlanStartStr = this._actualsPlanStartDate.format(this.dateFormat);

    }

    get actualsPlanStartDate(): moment.Moment {

        return moment(this._actualsPlanStartDate.clone(), this.dateFormat);

    }

    public IsSameStartDates(): boolean {
        return this.planStartStr == this.actualsPlanStartStr;
    }

    set planEndDate(v: any) {

        //if (typeof v === "string") this.planEndStr = v;
        this._planEndDate = moment(v, this.dateFormat);
        this.planEndStr = this._planEndDate.format(this.dateFormat);

    }

    get planEndDate() {

        return this._planEndDate;

    }

}